import React, { useState, useRef } from 'react';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    Paper,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import emailjs from '@emailjs/browser';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
const items = [
    {
        icon: <EmailIcon sx={{ fontSize: 40, color: '#1976d2', mb: 1 }} />,
        title: 'Email',
        line1: 'info@dreamflyholiday.com',
    },
    {
        icon: <PhoneIcon sx={{ fontSize: 40, color: '#388e3c', mb: 1 }} />,
        title: 'Phone Number',
        line2: '9643751779',
    },
    {
        icon: <LocationOnIcon sx={{ fontSize: 40, color: '#d32f2f', mb: 1 }} />,
        title: 'Address',
        line1: 'Sector 53, Noida, UP,',
    }
];



const Contact = () => {
    const [snakeBar, setSnakeBar] = useState(false);
    const [formData, setFormData] = useState({
        fullName: '',
        contactNumber: '',
        email: '',
        subject: '',
        query: ''
    });

    const [errors, setErrors] = useState({});


    // const [fullName, setFullName] = useState('');
    // const [email, setEmail] = useState('');
    // const [contactNumber, setContactNumber] = useState('');
    // const [subject, setSubject] = useState('');
    // const [query, setQuery] = useState('');


    const form = useRef('');

    const fieldRefs = {
        fullName: useRef(null),
        contactNumber: useRef(null),
        email: useRef(null),
        subject: useRef(null),
    };

    // 🔹 Field validation logic
    const validateField = (name, value) => {
        let message = "";

        switch (name) {
            case "fullName":
                if (!value.trim()) message = "Full name is required";
                break;
            case "contactNumber":
                if (!value.trim()) message = "Mobile number is required";
                else if (!/^\d{7,15}$/.test(value)) message = "Enter a valid number (7-15 digits)";
                break;
            case "email":
                if (!value.trim()) message = "Email is required";
                else if (!/\S+@\S+\.\S+/.test(value)) message = "Enter a valid email";
                break;
            case "subject":
                if (!value.trim()) message = "SUbject is required";
                break;
            default:
                break;
        }
        return message;
    };

    // 🔹 Handle change with instant validation
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Validate instantly
        const errorMsg = validateField(name, value);
        setErrors((prev) => ({ ...prev, [name]: errorMsg }));
    };

    // 🔹 Validate all fields
    const validateForm = () => {
        let tempErrors = {};
        Object.keys(formData).forEach((key) => {
            const msg = validateField(key, formData[key]);
            if (msg) tempErrors[key] = msg;
        });
        setErrors(tempErrors);

        // Auto-focus first invalid field
        if (Object.keys(tempErrors).length > 0) {
            const firstErrorField = Object.keys(tempErrors)[0];
            if (fieldRefs[firstErrorField]?.current) {
                fieldRefs[firstErrorField].current.focus();
            }
            return false;
        }

        return true;
    };

    const sendEmail = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        emailjs.sendForm('service_juwg5yr', 'template_wpjqmaa', form.current, 'mhKR7MXu_HnJfHnc9')
            .then((result) => {
                setSnakeBar(true);
                setFormData({
                    fullName: '',
                    contactNumber: '',
                    email: '',
                    subject: '',
                    query: ''
                });
                setErrors({});
            }, (error) => {
                console.log(error.text);
            });
    };

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleCloseSnakebar = (reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnakeBar(false);
    };

    return (
        <>
            <Snackbar open={snakeBar} autoHideDuration={6000} onClose={handleCloseSnakebar}>
                <Alert onClose={handleCloseSnakebar} severity="success" sx={{ width: '100%' }}>
                    Your Query has been sent successfully!
                </Alert>
            </Snackbar>
            <Box
                sx={{
                    width: '100%',
                    height: { xs: '220px', md: '400px' },
                    backgroundImage: `url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1950&q=80')`, // Unsplash beach photo
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#fff',
                        fontFamily: 'cursive',
                        fontSize: { xs: '24px', md: '48px' },
                        fontWeight: 'bold',
                        textShadow: '2px 2px 6px rgba(0,0,0,0.7)',
                    }}
                >
                    Dream Fly Holiday
                </Box>
            </Box>
            <Box sx={{ p: { xs: 2, md: 6, lg: 6 }, backgroundColor: '#f5f9fd' }}>
                {/* --- Top Info Section --- */}
                {/* --- Top Info Section --- */}
                <Grid container spacing={4} justifyContent="center" alignItems="center" mb={4}>
                    {items.map((item, index) => (
                        <Grid item size={{ xs: 12, sm: 5, md: 3, lg: 3 }} key={index}>
                            <Paper
                                sx={{
                                    p: 1,
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                        boxShadow: 6
                                    }
                                }}
                            >
                                {item.icon}
                                <Typography variant="h6" gutterBottom>{item.title}</Typography>
                                <Typography variant="body1">{item.line1}</Typography>
                                <Typography variant="body2">{item.line2}</Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>





                {/* --- Form & Map --- */}
                <Grid container spacing={4} justifyContent="center">
                    {/* --- Form --- */}
                    <Grid item size={{ xs: 12, sm: 10, md: 5, lg: 5 }}>
                        <Paper elevation={4} sx={{ p: 4 }}>
                            <Typography variant="h5" fontWeight="bold" gutterBottom>
                                Drop Us a Line
                            </Typography>
                            <Typography variant="body2" mb={3}>
                                Get in touch via form below and we will reply as soon as we can.
                            </Typography>

                            <Grid component="form" onSubmit={sendEmail} ref={form} container spacing={2} size={{ xs: 12 }}>
                                <Grid item size={{ xs: 12, md: 6, lg: 6 }}>
                                    <TextField label="Your Name" fullWidth
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        error={!!errors.fullName}
                                        helperText={errors.fullName}
                                        inputRef={fieldRefs.fullName}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6, lg: 6 }}>
                                    <TextField label="Email ID" fullWidth 
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        error={!!errors.email}
                                        helperText={errors.email}
                                        inputRef={fieldRefs.email}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6, lg: 6 }}>
                                    <TextField label="Phone No." fullWidth 
                                        name="contactNumber"
                                        type="tel"
                                        value={formData.contactNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Allow only digits
                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                handleChange(e);
                                            }
                                        }}
                                        error={!!errors.contactNumber}
                                        helperText={errors.contactNumber}
                                        inputRef={fieldRefs.contactNumber}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6, lg: 6 }}>
                                    <TextField label="Subject" fullWidth
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        error={!!errors.subject}
                                        helperText={errors.subject}
                                        inputRef={fieldRefs.subject}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 12, lg: 12 }}>
                                    <TextField
                                        label="Your Query"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        name="query"
                                        value={formData.query}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 12, lg: 12 }}>
                                    <Button variant="contained" type="submit" fullWidth sx={{ background: 'linear-gradient(to right, #e96443, #904e95)', }}>
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>

                    {/* --- Google Map --- */}
                    <Grid item size={{ xs: 12, sm: 10, md: 7, lg: 7 }}>
                        <Box
                            sx={{
                                width: '100%',
                                height: { xs: '300px', sm: '400px', md: '100%', lg: "100%" },
                                mt: { xs: 2, md: 0, lg: 0 },
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: 3,
                            }}
                        >
                            <iframe
                                title="Google Map"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                loading="lazy"
                                allowFullScreen
                                src="https://www.google.com/maps?q=Dream+Fly+Holiday,+2nd+floor,+MS+complex,+Gijhore,+sector+53,+Noida&output=embed"
                            ></iframe>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default Contact;
